<template>
    <v-app id="inspire">
        <!-- NAV DRAWER (menú hamburguesa) -->
        <v-navigation-drawer class="inicio-drawer" v-model="drawer" app :temporary="!$vuetify.breakpoint.mdAndUp" :mini-variant="mini && $vuetify.breakpoint.mdAndUp" floating>
            <v-list dense nav>
                <!-- Cabecera del menú (opcional) -->
                <v-list-item two-line>
                    <v-list-item-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">{{ $t('common.mainMenu') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <v-divider class="my-2"></v-divider>

                <!-- Ítems simples -->
                <v-list-item :to="{ name: 'Home' }" link>
                    <v-list-item-icon><v-icon>mdi-home</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.home') }}</v-list-item-title>
                </v-list-item>

                <!-- <v-list-group class="no-indent-group" prepend-icon="mdi-account-box-outline" no-action>
                    <template v-slot:activator>
                        <v-list-item-title>{{ $t('common.inbox') }}</v-list-item-title>
                    </template>
                    <v-list-item :to="{ name: 'perfil' }" link>
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('common.requests') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'perfils' }" link v-if="(rolOid == 1)">
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('common.requests') }}</v-list-item-title>
                    </v-list-item>
                </v-list-group> -->

                <v-list-item :to="{ name: 'perfil' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-account-box-outline</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.requests') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'funcionario' }" link  v-if="(rolOid == 1 || rolOid == 3 || rolOid == 4)">
                    <v-list-item-icon><v-icon>mdi-police-badge</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu0') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'map' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-earth</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu10') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'archivo' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu1') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admPlaneamiento' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu2') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admMovimiento' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu3') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admRegimen' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu4') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admEvaluacion' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu5') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admSalud' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu6') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admActivos' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu7') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admPlanilla' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu8') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admAcademica' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu9') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'admNomina' }" link  v-if="(rolOid == 1 || rolOid == 3)">
                    <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ $t('common.menu11') }}</v-list-item-title>
                </v-list-item>

                <v-list-group class="no-indent-group" prepend-icon="mdi-account-box-outline" no-action v-if="(rolOid == 1 || rolOid == 3)">
                    <template v-slot:activator>
                        <v-list-item-title>{{ $t('common.reports') }}</v-list-item-title>
                    </template>
                    <!-- <v-list-item :to="{ name: '', query: { tipoId: 1 } }" link>
                        <v-list-item-icon><v-icon>mdi-download</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('menu.report1') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: '', query: { tipoId: 2 } }" link>
                        <v-list-item-icon><v-icon>mdi-download</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('menu.report2') }}</v-list-item-title>
                    </v-list-item> -->
                    <v-list-item :to="{ name: 'dashboard' }" link>
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('menu.dashboardReport') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'repDistribucion' }" link>
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>Distribución Policial</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'repDinamico' }" link>
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>Reporte Dinamico Tabla</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'repGDinamico' }" link>
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>Reporte Dinamico Grafica</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'log' }" link>
                        <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
                        <v-list-item-title>Auditoria LOG</v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <v-list-group class="no-indent-group" prepend-icon="mdi-cog-outline" no-action  v-if="(rolOid == 1 || rolOid == 4)">
                    <template v-slot:activator>
                        <v-list-item-title>{{ $t('common.settings') }}</v-list-item-title>
                    </template>
                    <v-list-item :to="{ name: 'user' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-shield-key-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('common.accesses') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'actCorreos' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Actualizar Correos</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admCatalogo' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Catalogos</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admNivel' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Niveles</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admGrado' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Grados</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admCargo' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Cargos</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admUnidad' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Unidades</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admDestino' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Destinos</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admCas' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>CAS</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admFunciones' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Funciones</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admGPolicial' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Grado Policial</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'admFrontera' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>Frontera</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'estado' }" link v-if="(rolOid == 1 || rolOid == 4)">
                        <v-list-item-icon><v-icon>mdi-database-cog-outline</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ $t('common.states') }}</v-list-item-title>
                    </v-list-item>
                </v-list-group>

                <v-divider class="my-2"></v-divider>

                <!-- Cerrar sesión (si aplica)  -->
                <v-list-item v-if="userOid != null" @click="logounut">
                <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
                <v-list-item-title>Cerrar sesión</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <!-- APP BAR SUPERIOR -->
        <v-app-bar color="#383D18" dark app fixed height="80" :elevation="0" class="px-2">
            <!-- Botón hamburguesa -->
            <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="white"></v-app-bar-nav-icon>

            <v-img :src="require('@/assets/logobol2.png')" class="mr-2" max-height="80%" max-width="20%" contain />
            <!-- Logos <v-img :src="require('@/assets/logoun.png')" max-height="65%" max-width="11%" contain />-->

            <v-spacer></v-spacer>
            <!-- <v-icon color="#5e672c">mdi-earth</v-icon>
            <v-select v-model="currentLang" :items="languageOptions" item-text="text" item-value="value" dense outlined hide-details class="mr-4" 
            style="max-width: 90px; background-color: #5e672c;" @change="changeLanguage" /> -->

            <!-- Botón Inicio 
            <v-btn text :to="{ name: 'Home' }" color="rgb(0, 30, 67)">
                <v-icon left>mdi-home</v-icon>Inicio
            </v-btn>-->

            <!-- Menú de usuario -->
            <v-menu offset-y open-on-hover>
                
                <template v-slot:activator="{ on }">
                <v-btn text color="white" v-on="on">
                    <!-- <v-icon>mdi-account-circle</v-icon> -->
                        <b class="ml-1" v-if="userOid != null">{{ userName }}<!---{{ rolOid }}--></b> 
                    <b class="ml-1" v-else>Ingresar</b>
                </v-btn>
                </template>
                <v-list>
                    <v-list-item v-if="userOid != null" @click="logounut">
                        <v-list-item-title>Cerrar Sesión</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-else-if="userOid === null">
                        <v-list-item-title>Iniciar Sesión</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>

        <v-main class="inicio-main">
            <v-container fluid fill-height class="inicio-root">
                <v-slide-y-transition mode="out-in">
                    <router-view />
                </v-slide-y-transition>
            </v-container>
        </v-main>
        
        <!-- <v-footer padless class="footer-custom">
            <v-col cols="12" class="text-center white--text py-8">
                ©Developed and Supported by the ITS Team - UNODC ROCOL - <b>GESBOL</b> - Gestión Policial Boliviana
            </v-col>
        </v-footer> -->

        <!-- Formulario de creación/edición -->      
        <v-form ref="form" @submit.prevent="guardar">
        </v-form>
        
        <v-dialog v-model="dialog_cargando" max-width="550px"> 
                <v-card>
                    <v-card-title class="headline">Enviando código.....</v-card-title>
                </v-card>
        </v-dialog>

        <!-- Dialogoun para Mensaje Validando Loginn-->
        <v-dialog v-model="dialog_cargando2" max-width="550px"> 
            <v-card>
                <v-card-title class="headline">Validando .....</v-card-title>
            </v-card>
        </v-dialog>

        <!-- Dialogoun para Mensaje cargando-->
        <v-dialog v-model="dialog_guardando" max-width="550px"> 
            <v-card>
                <v-card-title class="headline">{{ $t('common.saving') }}</v-card-title>
            </v-card>
        </v-dialog>

        <!-- Mensaje de confirmación-->
        <v-snackbar v-model="guardarExitoso" color="success" top>
            {{ $t('common.save') }}
            <template v-slot:action="{ attrs }">
                <v-btn color="success" text v-bind="attrs" @click="registroExitoso = false">{{ $t('common.close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-snackbar v-model="snackbar" :timeout="3500" :color="snackbarColor" top>
            {{ snackbarMensaje }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
        </v-snackbar>

    </v-app>
</template>
  <script>
  import axios from 'axios';
  import { bus } from '../main.js';
  
  export default {
    name: "App",
    data() {
        return {
            datos: [],
            agencies: [],
            rols: [],
            datoUser: {
                oid: 0,
                name:'',
                surname: '',
                correo: '',
                oid_agency: 0,
                oid_rol: 0,
                pswd: '',
                pswd_act: null,
                fecha_pswd_act: null,
            },  
            correo: '',
            code_login: '', 
            acceso: 0,
            pswdv: '',
            verPswd: false,
            fixed: false,
            title: "Vuetify.js",
            dialog_guardando: false,
            guardarExitoso: false,    
            dialog_cargando: false,
            dialog_cargando2: false,
            dialog_registrar: false, loading: false,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'success',
            authTick: 0,
            drawer: null,  // null para que se autoajuste en mounted()
            mini: false,
            currentLang: localStorage.getItem('app_lang') || 'es',
            languageOptions: [
                { text: 'ES', value: 'es' },
                { text: 'EN', value: 'en' },
                { text: 'FR', value: 'fr' },
                { text: 'AR', value: 'ar' },
                { text: 'ZH', value: 'zh' }
            ],
            sessionTimeout: null,
            usuariosCon30Min: [ 6, 10 ],
        };
    },
    computed: {
        userName() {
            return localStorage.getItem('userName'); 
        },
        rolOid() { 
            return Number(localStorage.getItem('rolu'));
        },    
        userOid() { 
            return localStorage.getItem('oidu');
        },
    },    
    mounted() {
        this.iniciarTimeoutSesion();

        // Detectar movimiento, teclas o clics
        window.addEventListener('mousemove', this.reiniciarSesion);
        window.addEventListener('keydown', this.reiniciarSesion);
        window.addEventListener('click', this.reiniciarSesion);
        // Abrir fijo en desktop, temporal en mobile
        this.drawer = this.$vuetify.breakpoint.mdAndUp;
    },
    beforeDestroy() {
        clearTimeout(this.sessionTimeout);
        window.removeEventListener('mousemove', this.reiniciarSesion);
        window.removeEventListener('keydown', this.reiniciarSesion);
        window.removeEventListener('click', this.reiniciarSesion);
    },
    methods: {
        logounut() {        
            localStorage.removeItem('userName');
            localStorage.removeItem('oidu');
            localStorage.removeItem('rolu');    
            
            this.$router.replace({name:'/'});
            window.location.reload();
        },
        changeLanguage(lang) {
            this.$i18n.locale = lang;
            localStorage.setItem('app_lang', lang);
        },
        getIdleTimeoutMs() {
            // Regla: si el usuario está en la lista especial -> 30 min; si no -> 5 min
            const ESPECIAL = this.usuariosCon30Min.includes(this.userOid);
            return ESPECIAL ? 30 * 60 * 1000 : 10 * 60 * 1000;
            //}, 15 * 60 * 1000); // 15 minutos
            //}, 20 * 1000); //20 segundos
        },
        iniciarTimeoutSesion() {
            if (this.sessionTimeout) clearTimeout(this.sessionTimeout);

            const timeoutMs = this.getIdleTimeoutMs();
            this.sessionTimeout = setTimeout(() => {
                this.cerrarSesionPorInactividad();
            }, timeoutMs);
        },
        reiniciarSesion() {
            this.iniciarTimeoutSesion();
        },
        cerrarSesionPorInactividad() {
            alert('Sesión expirada por inactividad.');
            localStorage.clear();
            this.$router.replace({ name: '/' });
            window.location.reload();
        },
    }
};
</script>
  <style>
      p {
          font-family: 'Heebo', sans-serif;
          font-size: 16px;        
          line-height: 1.6em;
      }
      .hover-show {
      opacity: 0;
      transition: opacity 0.3s ease;
      position: relative;
  }
  
  .hover-show:hover {
      opacity: 1;
  }
  
  .menu-indicator {
      position: absolute;
      color: #555; /* Cambia el color de la flecha según tu diseño */
  }
  
    .footer-custom {
        background-color: #838858 !important; /* Azul sólido */
    }

    .inicio-app-bar {
        background-color: #46501f !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
    }

    .inicio-app-logo {
        margin-left: 20px;
    }

    .inicio-user-btn {
        letter-spacing: 0.04em;
    }

    @media (max-width: 600px) {
        .inicio-app-logo {
            margin-left: 8px;
            max-width: 190px !important;
        }

        .inicio-user-btn {
            max-width: 130px;
        }

        .inicio-user-btn .v-btn__content {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    /* Quita la sangría de los hijos del grupo */
    .no-indent-group .v-list-group__items {
    padding-left: 0 !important;
    }
    .no-indent-group .v-list-group__items .v-list-item {
    padding-left: 0 !important;   /* elimina el extra de cada item */
    }

    /* (Opcional) ajusta el espacio del icono si usas v-list-item-icon */
    .no-indent-group .v-list-item__icon {
    margin-right: 12px; /* o el valor que prefieras */
    }
    .prodocs-wrap {
        position: relative;
        /* 100vh menos app-bar (80px) y footer (~56px) */
        min-height: calc(100vh - 80px - 56px);
        /* un poquito de respiro bajo para que no “toque” el footer */
        padding-bottom: 16px;
    }

    .inicio-drawer {
        background: linear-gradient(180deg, #edf0e8 0%, #e6eadf 100%) !important;
        border-right: 1px solid rgba(108, 117, 51, 0.12) !important;
    }

    .inicio-main {
        background:
            radial-gradient(circle at top right, rgba(201, 165, 56, 0.12), transparent 26%),
            linear-gradient(180deg, #f7f8f3 0%, #eef0ea 100%);
    }

    .inicio-root {
        padding: 20px;
        padding-bottom: 48px;
        box-sizing: border-box;
        min-height: calc(100vh - 80px);
        align-items: stretch;
    }

    @media (max-width: 960px) {
        .inicio-root {
            padding: 14px;
            padding-bottom: 36px;
        }
    }

  </style>
